import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../service/user.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  adm: boolean = false;

  constructor(
    private router: Router,
    private service: UserService,
  ) { }

  ngOnInit(): void {
    this.getUserPermission()
  }
  getUserPermission = async () => {
    await this.service.userIsAdmin().subscribe(adm => {
      if (adm) this.adm = true;


    })
  }

  form = () => {
    this.router.navigateByUrl('adm/form/list')
  }

  listUser() {
    this.router.navigateByUrl('adm/users/list')
  }

  pc003() {
    this.router.navigateByUrl('adm/pc003/list')
  }

  listPc003Estrategia() {
    this.router.navigateByUrl('adm/pc003-estrategia/list')
  }

  humity() {
    this.router.navigateByUrl('adm/humidity/list')
  }
}
